import { reactive, markRaw, type Component, type InjectionKey } from 'vue'

export interface ModalOptions {
    title?: string
    width?: string
    maxWidth?: string
    height?: string
}

export interface ModalEntry {
    id: number
    component: Component
    props: Record<string, any>
    options: ModalOptions
    resolve: (result: any) => void
}

export const MODAL_CLOSE: InjectionKey<(result?: any) => void> = Symbol('modalClose')

const state = reactive({
    stack: [] as ModalEntry[],
    nextId: 0
})

const ModalService = {
    get stack() { return state.stack },

    open<T = any>(
        component: Component,
        props?: Record<string, any>,
        options?: ModalOptions
    ): Promise<T | undefined> {
        return new Promise<T | undefined>((resolve) => {
            state.stack.push({
                id: state.nextId++,
                component: markRaw(component),
                props: props ?? {},
                options: options ?? {},
                resolve
            })
        })
    },

    closeById(id: number, result?: any) {
        const idx = state.stack.findIndex(m => m.id === id)
        if (idx < 0) return
        const entry = state.stack[idx]
        state.stack.splice(idx, 1)
        entry.resolve(result)
    },

    close(result?: any) {
        if (state.stack.length === 0) return
        const entry = state.stack.pop()!
        entry.resolve(result)
    },

    closeAll() {
        while (state.stack.length > 0) {
            const entry = state.stack.pop()!
            entry.resolve(undefined)
        }
    }
}

export default ModalService
